<template>
  <div class="dotted">
    <slot />
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="sass" scoped>
.dotted
  cursor: pointer
  padding-bottom: 1px
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTg5IiBoZWlnaHQ9IjIiIHZpZXdCb3g9IjAgMCAxODkgMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMUgxODkiIHN0cm9rZT0iI0FGQUZBRiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1kYXNoYXJyYXk9IjEuNSAyIi8+Cjwvc3ZnPgo=")
  background-repeat: repeat-x
  background-position-y: 100%
  @include for-mob
    width: fit-content
</style>